import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImageUp, Loader2, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../lib/api";

export const ProofUpload = ({ order, k, onUploaded }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const count = order?.proof_count ?? 0;

  if (!["crypto", "cashapp", "paypal", "applepay"].includes(order?.payment_method) || order?.status !== "awaiting_payment") return null;

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      toast.error("Image is too large (max 8 MB)");
      return;
    }
    const form = new FormData();
    form.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${order.id}/proof`, form, { params: { k } });
      onUploaded(data?.proof_count ?? count + 1);
      toast.success("Screenshot sent — we'll confirm your payment soon");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-6 border border-dashed border-[#a259ff]/50 bg-[#a259ff]/5 p-5" data-testid="proof-upload">
      <p className="font-mono text-[11px] uppercase tracking-widest text-violet-300">Payment screenshot</p>
      <p className="mt-2 text-sm text-slate-300">Paid already? Upload a screenshot of the payment so we can confirm it faster.</p>
      {count > 0 && (
        <p className="mt-3 flex items-center gap-2 text-sm text-white" data-testid="proof-count">
          <CheckCircle2 className="h-4 w-4 text-[#a259ff]" /> {count} screenshot{count > 1 ? "s" : ""} received
        </p>
      )}
      <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/heic" onChange={upload} className="hidden" data-testid="proof-file-input" />
      {count < 3 && (
        <button onClick={() => input.current?.click()} disabled={busy} data-testid="proof-upload-button" className="mt-4 flex items-center gap-2 rounded-full bg-[#a259ff] px-5 py-3 font-mono text-xs font-bold uppercase tracking-widest text-black transition-shadow hover:shadow-[0_0_30px_rgba(162,89,255,0.5)] disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImageUp className="h-4 w-4" />} {count ? "Add another" : "Upload screenshot"}
        </button>
      )}
      <p className="mt-3 text-xs text-slate-400">JPG, PNG, WEBP or HEIC · max 8 MB · up to 3</p>
    </div>
  );
};
